import { render } from "./Risk.vue?vue&type=template&id=7d21c752&scoped=true"
import script from "./Risk.vue?vue&type=script&lang=js"
export * from "./Risk.vue?vue&type=script&lang=js"

import "./Risk.vue?vue&type=style&index=0&id=7d21c752&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d21c752"]])

export default __exports__